import {createUserManager} from 'redux-oidc';

const AUTHORITY_URL = {
	LOCAL: 'https://login-at.dts.utah.gov:443/sso/oauth2',
	DEV: 'https://login-dev.dts.utah.gov:443/sso/oauth2',
	AT: 'https://login-at.dts.utah.gov:443/sso/oauth2',
	PROD: 'https://login.dts.utah.gov:443/sso/oauth2'
};

export const currentAuthority = (document.location.hostname.includes('localhost')) ? AUTHORITY_URL.LOCAL
	: (document.location.hostname.includes('.dev.')) ? AUTHORITY_URL.DEV
		: (document.location.hostname.includes('.at.')) ? AUTHORITY_URL.AT
			: AUTHORITY_URL.PROD;


const userManagerConfig = {
	client_id: 'uncrowns-interweld',
	// tell where to go once user is logged in: must be an entry in apadmin
	redirect_uri: `${window.location.origin}/login/callback`,
	// refreshes token behind the scenes: must be an entry in apadmin
	silent_redirect_uri: `${window.location.origin}/silent_renew.html`,

	response_type: 'id_token token',
	scope: 'openid profile email directory',
	authority: currentAuthority,
	automaticSilentRenew: true,
	filterProtocolClaims: false,
	loadUserInfo: true,
};

const userManager = createUserManager(userManagerConfig);

export default userManager;
